var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "mt-3",
    attrs: {
      headers: _vm.headers,
      items: _vm.tasks,
      "items-per-page-items": [15, 50, 100, -1],
      "footer-props": { "items-per-page-options": [15, 50, 100, -1] },
      "items-per-page": _vm.paginationActivityCreate.rowsPerPage
    },
    on: {
      "update:itemsPerPage": function($event) {
        return _vm.$set(_vm.paginationActivityCreate, "rowsPerPage", $event)
      },
      "update:items-per-page": function($event) {
        return _vm.$set(_vm.paginationActivityCreate, "rowsPerPage", $event)
      },
      pagination: function($event) {
        return _vm.setRowsOnLocalStorage(
          _vm.dataTableActivityCreateTaskId,
          _vm.paginationActivityCreate.rowsPerPage
        )
      }
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function(props) {
          return [
            _c("tr", [
              _c("td", [_vm._v(_vm._s(props.item.type))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(props.item.title))])
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7791cfda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7791cfda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/ActivityCreate/ActivityCreateTasks.vue
// module id = null
// module chunks = 